import { render, staticRenderFns } from "./AddNewInstanceDialogButton.vue?vue&type=template&id=3776e816"
import script from "./AddNewInstanceDialogButton.vue?vue&type=script&lang=js"
export * from "./AddNewInstanceDialogButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports